export default __webpack_public_path__ + "static/affiliate-program-AffiliateApp@mob2x-6ec95da92b6e736f8a530597c8c8f210.webp";